import { filterVentasIreneByUser } from "./ventasIreneUtils";

export function normalizeRepAlias(row) {
  const cli = (row.CLIPRO || "").toUpperCase().trim();
  if (cli.includes("SILBON ESPAÑA")) {
    return "MIKAEL SOUBIES";
  }
  return row.REPALIAS;
}

/** Misma fórmula que la tabla reducida (totales por mes). */
export function calcMargenMes(m) {
  if ((m.InvSalesMoneda ?? 0) !== 0 || (m.InvCostMoneda ?? 0) !== 0) {
    return (m.InvSalesMoneda ?? 0) + (m.InvCostMoneda ?? 0);
  }
  return (m.VentaBaseEUR ?? 0) + (m.PedidoCompraE ?? 0);
}

export const filterMargenByUser = filterVentasIreneByUser;
